// import { Col, Row } from "@/utils/bootstrap";

import { DOMAttributes, JSX, PropsWithChildren } from "react";
import { Col, Row } from "./my-bootstrap";
import { Link } from "./navigation/Link";

interface Props {
  startLabel: JSX.Element | string;
  marginBottom?: number;
  endLabel?: {
    label: string;
    href?: string;
    onClick?: DOMAttributes<HTMLDivElement>["onClick"];
  };
  secondary?: boolean;
}

const Separator: React.FC<Props> = ({
  startLabel,
  marginBottom = 16,
  endLabel,
  secondary = false,
}) => {
  if (!startLabel && !endLabel) return null;
  return (
    <Row
      className="separator-container w-100"
      style={{ gap: 16, margin: `0 0 ${marginBottom}px 0` }}
    >
      <Col
        className={`p-0 col-auto start-label ${secondary ? "secondary" : ""}`}
      >
        <h2 className="start-label">{startLabel}</h2>
      </Col>
      <Col className=" p-0 separator" />
      {endLabel && (
        <EndLableWapper href={endLabel?.href}>
          <div className="separator-url" onClick={endLabel?.onClick}>
            {endLabel.label}
          </div>
        </EndLableWapper>
      )}
    </Row>
  );
};

export default Separator;

const EndLableWapper: React.FC<PropsWithChildren<{ href?: string }>> = ({
  href,
  children,
}) =>
  href ? (
    <Col className="col-auto p-0 ">
      <Link prefetch={false} href={href}>
        {children}
      </Link>
    </Col>
  ) : (
    <Col className="col-auto p-0 ">{children}</Col>
  );
